import { render, staticRenderFns } from "./advantageResources.vue?vue&type=template&id=5151d7e2&scoped=true"
import script from "./advantageResources.vue?vue&type=script&lang=js"
export * from "./advantageResources.vue?vue&type=script&lang=js"
import style0 from "./advantageResources.vue?vue&type=style&index=0&id=5151d7e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151d7e2",
  null
  
)

export default component.exports